import React, { FunctionComponent, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import LoadingSpinner from '../../../components/loading-spinner/LoadingSpinner';
import { useAccount } from '../../../hooks/useAccount';
import { useCheckoutFlow } from '../../../hooks/useAccountMutations';
import { Subscription } from '../../../services/models/subscription';

type PageParams = {
  planId: string;
};

const PlanCheckoutPage: FunctionComponent = () => {
  const history = useHistory();

  const { planId } = useParams<PageParams>();

  const { account } = useAccount();
  const { initCheckoutFlow } = useCheckoutFlow();
  const subscription = account?.subscription as Subscription;

  const [currentPlanId] = useState(subscription.planId);

  useEffect(() => {
    initCheckoutFlow(planId);

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (subscription.planId !== currentPlanId) {
      history.goBack();

      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  }, [subscription, history, currentPlanId]);

  return <LoadingSpinner />;
};

export default PlanCheckoutPage;
